/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Transactions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AgGrid from 'DesignSystem/AgGrid/react'
import FilterBy from './FilterBy/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Transactions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions",
  height,
  columnDefs,
  rowData
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Transactions.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-2v07He': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-2v07He': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-2v07He': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-2v07He': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-2v07He': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Transactions.Vertical:1"
  data-view-path={viewPath}
 style={{'--btc-6-2v07He': dtColorsNeutral200,'--bc-5-2v07He': dtColorsWhite}}
 className={`views-block ${styles.Vertical1}`}
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 disableAutoSizeStrategy={true}
 height={height}
 headerHeight={36}
 rowHeight={44}
 rowGroupPanelShow="never"
 verticalBorders={true}
 overlayNoRowsTemplate="No transactions found"
 columnDefs={columnDefs}
 rowData={rowData}
 suppressCellFocus={true}
/>
</div>
</div>
<FilterBy
  viewPath={`${viewPath}/FilterBy`}
/>
{children}
</React.Fragment>)
}